export default __webpack_public_path__ + "static/media/dobbi-logo-white.fcf4ae86.png";